import PropTypes from 'prop-types';
import {
  RAGSTATUS_RED_FROMINTERVAL,
  RAGSTATUS_AMBER_FROMINTERVAL,
  ENABLE_MILEAGE_CAP,
  RAGSTATUS_RED_FROMINTERVAL_DEFAULT,
  RAGSTATUS_AMBER_FROMINTERVAL_DEFAULT,
  ENABLE_MILEAGE_CAP_DEFAULT,
} from '../../settings/constants/appSettings';

const appSettingsDefault = {
  [RAGSTATUS_AMBER_FROMINTERVAL]: RAGSTATUS_AMBER_FROMINTERVAL_DEFAULT,
  [RAGSTATUS_RED_FROMINTERVAL]: RAGSTATUS_RED_FROMINTERVAL_DEFAULT,
  [ENABLE_MILEAGE_CAP]: ENABLE_MILEAGE_CAP_DEFAULT,
};

const appSettingsPropTypes = PropTypes.shape({
  [RAGSTATUS_AMBER_FROMINTERVAL]: PropTypes.string,
  [RAGSTATUS_RED_FROMINTERVAL]: PropTypes.string,
});

export { appSettingsPropTypes, appSettingsDefault };
